import * as StoreUtils from "../../utils/StoreUtils";
import {
	UPDATE_SUBTITLES,
	CLEAR_SUBTITLES,
} from "../constants/ActionConstants";

export function updateSubtitles(updates) {
	StoreUtils.getStore().dispatch(_updateSubtitles(updates));
}

function _updateSubtitles(items) {
	return (dispatch: (action) => void) => {
		dispatch({ items, type: UPDATE_SUBTITLES });
	};
}

export function clearSubtitles() {
	StoreUtils.getStore().dispatch(_clearSubtitles());
}

function _clearSubtitles() {
	return (dispatch: (action) => void) => {
		dispatch({ type: CLEAR_SUBTITLES });
	};
}
